/**
 * Returns a copy of `source` holding only `keys` that are present on it. Pure.
 *
 * A profile section panel sends just its own fields, so a partial save never
 * carries another section's empty values (MYN-217, profile-redesign NFR-25).
 *
 * @param source - the object to copy from.
 * @param keys - the keys to keep.
 * @returns a new object with those keys; keys absent from `source` are omitted.
 */
export function pickKeys<T extends object, K extends string>(
  source: T,
  keys: readonly K[],
): Partial<T> {
  const picked: Record<string, unknown> = {};
  for (const key of keys) {
    if (key in source) picked[key] = (source as Record<string, unknown>)[key];
  }
  return picked as Partial<T>;
}
